<script>
import { mapActions, mapMutations } from 'vuex';
import Segment from '@/Segment';

// Signup has no platform picker. We force an explicit platform so the value sent to the
// backend always matches the sendPlatform reported on the event — no reliance on a backend
// default that could drift. OtpMixin, when mixed in, overrides this via sendPlatform.
const DEFAULT_SEND_PLATFORM = 'sms';

export default {
  name: 'GenerateCodeMixin',
  methods: {
    ...mapActions('signup', ['generateCode']),
    ...mapMutations('signup', ['setFirstName', 'setLastName', 'setPhoneNumber', 'setEmail', 'setEnableMarketingEmails']),
    async generateCodeForSignup(firstName, lastName, phoneNumber, email, enableMarketingEmails) {
      await this.setFirstName(firstName);
      await this.setLastName(lastName);
      await this.setPhoneNumber(phoneNumber);
      await this.setEmail(email);
      await this.setEnableMarketingEmails(enableMarketingEmails);
      const sendPlatform = this.sendPlatform || DEFAULT_SEND_PLATFORM;
      Segment.trackUserInteraction('GenerateCodeClicked_Marketing');
      Segment.trackUserInteraction('GenerateCodeClicked', {
        firstName: this.firstName,
        lastName: this.lastName,
        phoneNumber: this.phoneNumber,
        isMarketingConsent: this.enableMarketingEmails,
        sendPlatform,
      });
      await this.generateCode({ sendPlatform });
    },
  },
};
</script>
